import React, { FC, ReactElement, useRef, useState } from 'react'
import ReactDOM from 'react-dom'
import { StyleSheetManager } from 'styled-components'
import MainComponent from 'components/MainComponent'

const App: FC<MicroFrontendProps> = (microFrontendProps): ReactElement => {
  const [ref, setRef] = useState<HTMLDivElement | null>()
  const styleRef = useRef<any>()
  const [cssIsLoaded, setCssIsLoaded] = useState(false)

  if (styleRef.current) {
    styleRef.current.onload = () => {
      setCssIsLoaded(true)
    }
  }

  return (
    <div id='root' ref={(newRef) => setRef(newRef)}>
      <link
        ref={styleRef}
        rel='stylesheet'
        href={process.env.REACT_APP_DEPLOY_PATH + '/static/css/main.css'}
      />
      {ref && cssIsLoaded && (
        <div id='app'>
          <StyleSheetManager target={ref}>
            <MainComponent {...microFrontendProps} />
          </StyleSheetManager>
        </div>
      )}
    </div>
  )
}
export default App

if (window.document.title === 'TA-Interaktiv Microfrontend') {
  ReactDOM.render(
    <React.StrictMode>
      <App
        tenant={{
          domain: 'tagesanzeiger',
          feedId: 2,
          key: 'tagesanzeiger',
          lang: 'de',
          name: 'Tages-Anzeiger',
        }}
        colorMode={'light'}
      />
    </React.StrictMode>,
    document.getElementById('root')
  )
}
